import BaseDataProvider from './BaseDataProvider';

class GitlabFeatureFlagsDataProvider extends BaseDataProvider {
	getFeatureFlags() {
		return this.getNoCache('/api/v1/feature_flags/');
	}
}

export default new GitlabFeatureFlagsDataProvider();
